// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".MetricsContainer {\n  display: flex; }\n\n.MetricsContainer__counter {\n  display: flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-right: 1px solid #F0F0F0;\n  width: 110px; }\n  .MetricsContainer__counter label {\n    font-weight: bold;\n    font-size: 16px;\n    padding: 0 10px; }\n  .MetricsContainer__counter div {\n    font-weight: 500;\n    font-size: 12px; }\n", ""]);
// Exports
module.exports = exports;
